/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Share_New_Share_ButtonInputs */

const en_team_share_new_share_button = /** @type {(inputs: Team_Share_New_Share_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New Share`)
};

const fr_team_share_new_share_button = /** @type {(inputs: Team_Share_New_Share_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouveau partage`)
};

const de_team_share_new_share_button = /** @type {(inputs: Team_Share_New_Share_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neue Aktie`)
};

const it_team_share_new_share_button = /** @type {(inputs: Team_Share_New_Share_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuova condivisione`)
};

const ru_team_share_new_share_button = /** @type {(inputs: Team_Share_New_Share_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Новая акция`)
};

const es_team_share_new_share_button = /** @type {(inputs: Team_Share_New_Share_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nueva acción`)
};

const zh_cn2_team_share_new_share_button = /** @type {(inputs: Team_Share_New_Share_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新股`)
};

const ja_team_share_new_share_button = /** @type {(inputs: Team_Share_New_Share_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しいシェア`)
};

const hi_team_share_new_share_button = /** @type {(inputs: Team_Share_New_Share_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नया शेयर`)
};

const pt_pt2_team_share_new_share_button = /** @type {(inputs: Team_Share_New_Share_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Novo Compartilhar`)
};

/**
* | output |
* | --- |
* | "New Share" |
*
* @param {Team_Share_New_Share_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_new_share_button = /** @type {((inputs?: Team_Share_New_Share_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_New_Share_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_share_new_share_button(inputs)
	if (locale === "de") return de_team_share_new_share_button(inputs)
	if (locale === "it") return it_team_share_new_share_button(inputs)
	if (locale === "ru") return ru_team_share_new_share_button(inputs)
	if (locale === "es") return es_team_share_new_share_button(inputs)
	if (locale === "zh-CN") return zh_cn2_team_share_new_share_button(inputs)
	if (locale === "ja") return ja_team_share_new_share_button(inputs)
	if (locale === "hi") return hi_team_share_new_share_button(inputs)
	if (locale === "pt-PT") return pt_pt2_team_share_new_share_button(inputs)
	return en_team_share_new_share_button(inputs)
});